 
import './App.scss';
import Home from './pages/Home';
function App() {
  return (
    <div className="App">

      <div className="bg"></div>  
      <Home />
    </div>
  );
}

export default App;
 